import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';

const EventDetails = observer(({uiState}) => {
  const {interviewSchedule} = uiState.interviewInvite;
  const {interviewers, duration, location, eventDescription, videoConferencingProvider} = interviewSchedule;
  const locationKey = location === 'video_conferencing'
    ? `recruiting.schedule_interview.location.video_conferencing_provider.${videoConferencingProvider}`
    : `recruiting.schedule_interview.location.${location}`;

  return (
    <>
      <div className='flex'>
        <i className='material-icons align-middle mr1'>{'people'}</i>
        {interviewers.join(', ')}
      </div>
      <div className='flex'>
        <i className='material-icons align-middle mr1'>{'schedule'}</i>
        <FormattedMessage
          id='recruiting.schedule_interview.DURATION'
          values={{hours: Math.floor(duration / 60), minutes: duration % 60}}
        />
      </div>
      <div className='flex'>
        <i className='material-icons align-middle mr1'>{'place'}</i>
        <FormattedMessage id={locationKey}/>
      </div>
      {eventDescription && <span className='whitespace-pre-wrap jumbo'>{eventDescription}</span>}
    </>
  );
});

export default EventDetails;
